import { AppState } from '../../bootstrap/redux/state/AppState';
import { ISpaceTypeInfo } from '../models/resourceInfoParts';
import { SpaceInfo } from '../state/SpaceInfo';

export function selectSpaceInfo(state: AppState): SpaceInfo {
  return state.spaceInfo;
}

export function selectSpaceInfoItem(state: AppState): ISpaceTypeInfo {
    return state.spaceInfo.item;
}
